module.exports = __webpack_public_path__ + "img/fallback_080_l.d112f111.jpg";